import React from 'react'

import { RibbonTriggerContainer } from 'RibbonTrigger'

import { DeliveryDetailsForm } from 'routes/Checkout/Components/DeliveryDetailsForm'
import { CheckoutStepIds } from 'routes/Checkout/checkoutConfig'

type DeliveryProps = {
  onStepChange: (stepId: CheckoutStepIds) => void
}

export const Delivery = ({ onStepChange }: DeliveryProps) => (
  <>
    <DeliveryDetailsForm onStepChange={onStepChange} />

    <RibbonTriggerContainer name="checkout-delivery" />
  </>
)
